/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { Property } from './Property';
import {
    PropertyFromJSON,
    PropertyFromJSONTyped,
    PropertyToJSON,
    PropertyToJSONTyped,
} from './Property';
import type { Link } from './Link';
import {
    LinkFromJSON,
    LinkFromJSONTyped,
    LinkToJSON,
    LinkToJSONTyped,
} from './Link';

/**
 * 
 * @export
 * @interface Party
 */
export interface Party {
    /**
     * 
     * @type {string}
     * @memberof Party
     */
    tenantId?: string;
    /**
     * 
     * @type {number}
     * @memberof Party
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Party
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Party
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Party
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Party
     */
    shortName?: string;
    /**
     * 
     * @type {Array<Address>}
     * @memberof Party
     */
    addresses?: Array<Address>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Party
     */
    emailAddresses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Party
     */
    telephoneNumbers?: Array<string>;
    /**
     * 
     * @type {Array<Property>}
     * @memberof Party
     */
    props?: Array<Property>;
    /**
     * 
     * @type {Array<Link>}
     * @memberof Party
     */
    links?: Array<Link>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Party
     */
    locationUuids?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Party
     */
    externalIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Party
     */
    remarks?: string;
}

/**
 * Check if a given object implements the Party interface.
 */
export function instanceOfParty(value: object): value is Party {
    return true;
}

export function PartyFromJSON(json: any): Party {
    return PartyFromJSONTyped(json, false);
}

export function PartyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Party {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'type': json['type'] == null ? undefined : json['type'],
        'name': json['name'] == null ? undefined : json['name'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'addresses': json['addresses'] == null ? undefined : ((json['addresses'] as Array<any>).map(AddressFromJSON)),
        'emailAddresses': json['emailAddresses'] == null ? undefined : json['emailAddresses'],
        'telephoneNumbers': json['telephoneNumbers'] == null ? undefined : json['telephoneNumbers'],
        'props': json['props'] == null ? undefined : ((json['props'] as Array<any>).map(PropertyFromJSON)),
        'links': json['links'] == null ? undefined : ((json['links'] as Array<any>).map(LinkFromJSON)),
        'locationUuids': json['locationUuids'] == null ? undefined : json['locationUuids'],
        'externalIds': json['externalIds'] == null ? undefined : json['externalIds'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function PartyToJSON(json: any): Party {
    return PartyToJSONTyped(json, false);
}

export function PartyToJSONTyped(value?: Party | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'uuid': value['uuid'],
        'type': value['type'],
        'name': value['name'],
        'shortName': value['shortName'],
        'addresses': value['addresses'] == null ? undefined : ((value['addresses'] as Array<any>).map(AddressToJSON)),
        'emailAddresses': value['emailAddresses'],
        'telephoneNumbers': value['telephoneNumbers'],
        'props': value['props'] == null ? undefined : ((value['props'] as Array<any>).map(PropertyToJSON)),
        'links': value['links'] == null ? undefined : ((value['links'] as Array<any>).map(LinkToJSON)),
        'locationUuids': value['locationUuids'],
        'externalIds': value['externalIds'],
        'remarks': value['remarks'],
    };
}

